import { defineAsyncComponent } from 'vue'

export const ArtistPlaceholder = defineAsyncComponent(() => import('./ArtistPlaceholder.vue'))
export const GridArtistsPlaceholder = defineAsyncComponent(() => import('./GridArtistsPlaceholder.vue'))
export const SlidePlaceholder = defineAsyncComponent(() => import('./SlidePlaceholder.vue'))
export const EventCardPlaceholder = defineAsyncComponent(() => import('./EventCardPlaceholder.vue'))
export const TilePlaceholder = defineAsyncComponent(() => import('./TilePlaceholder.vue'))